<template>
    <section class="registraion_area" style="padding-top:0px;padding-bottom:0px;">
        <div class="container">
            <div class="row">
                <div class="col-md-8 col-md-offset-2">
                    <div class="registration_box_area reg-box-custom">
                        <div class="registration_box">
                            <div class="registration_box_all_conts">
                                <div class="registration_logo text-center">
                                    <img src="images/logo.png" alt="">
                                </div>
                                <div class="registration_title text-center">
                                    <h6>Bejelentkezés</h6>
                                </div>
                            </div>

                            <form id="login">
                                <div class="row">
                                    <div class="col-md-8 col-md-offset-2">
                                        <div class="form-group">
                                            <input class="form-control" id="username" type="text" placeholder="E-mail cím" autofocus="" required="" v-model="email">
                                        </div>
                                    </div>
                                    <div class="col-md-8 col-md-offset-2">
                                        <div class="form-group log_dec">
                                            <input class="form-control" id="password" type="password" placeholder="Jelszó" required="" v-model="password">
                                        </div>

                                    </div>

                                    <div class="login_buttons">
                                        <div class="row">
                                            <div class="col-sm-12">
                                                <div class="connection_btn">
                                                    <div class="sub_button text-center">
                                                        <input class="btn btn-default" type="button" @click="login" value="Belépés">
                                                    </div>
                                                    <div class="elfe">
                                                        <a data-toggle="modal" data-target="#dialog2">Elfelejtett jelszó</a>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="login_buttons_two">
                                        <div class="row">
                                            <div class="col-sm-12">
                                                <div class="registration_title text-center">
                                                    <h6>Nem vagy még tag?</h6>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-8 col-md-offset-2">
                                            <div class="form-group">
                                                <input class="form-control" id="username" type="text" placeholder="A fentieken kívül add meg a nevedet is" autofocus="" v-model="name">
                                            </div>

                                            <input type="checkbox" v-model="newsletter">  Kérek rendszeres hírlevelet</input>

                                        </div>
                                        <div class="row">
                                            <div class="col-sm-12">
                                                <div class="connection_btn">
                                                    <div class="sub_button text-center">
                                                        <input class="btn btn-default" type="button" @click="register" value="Regisztráció">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- <div class="row">
                                            <div class="col-sm-12">
                                                <div class="connection_btn gmailbtn">
                                                    <div class="g_btn text-center">
                                                        <a href="#"><img src="images/g.png" alt="">Bejelentkezés Google+ fiókkal</a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div> -->

                                        <!-- <div class="row">
                                            <div class="col-sm-12">
                                                <div class=" fbtn">
                                                    <div class="g_btn text-center">
                                                        <a @click="facebookLogin"><img class="no-margin" src="images/f.png" alt="">Bejelentkezés Facebook fiókkal</a>
                                                    </div>
                                                </div>

                                            </div>
                                        </div> -->

                                    </div>

                                </div>
                            </form>

                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal -->
          <div class="modal fade" id="dialog" role="dialog">
            <div class="modal-dialog modal-lg">
              <div class="modal-content">
                <div class="modal-header">
                  <button type="button" class="close" data-dismiss="modal">&times;</button>
                  <h4 class="modal-title">Kosarak egyesítése</h4>
                </div>
                <div class="modal-body">
                    <p>
                        A bejelentkezett felhasználód kosarában is találhatók termékek. Szeretnéd azokat is hozzáadni a vásárláshoz?
                    </p>
                </div>
                <div class="modal-footer">
                  <button type="button" class="btn btn-default" data-dismiss="modal" @click="dialogClicked(false)">Nem</button>
                  <button type="button" class="btn btn-success" data-dismiss="modal" @click="dialogClicked(true)">Igen</button>
                </div>
              </div>
            </div>
          </div>

          <!-- forgotten pass modal -->
            <div class="modal fade" id="dialog2" role="dialog">
              <div class="modal-dialog modal-lg">
                <div class="modal-content">
                  <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                    <h4 class="modal-title">Elfelejtett jelszó igénylése</h4>
                  </div>
                  <div class="modal-body">
                      <p>
                          Emlékeztető email igényléséhez írd be az alábbi mezőbe az email címedet, amivel regisztráltál. Erre fogsz kapni egy levelet a további teendőkkel.
                      </p>
                      <div class="form-group">
                          <input class="form-control" id="username" type="email" placeholder="E-mail cím" autofocus="" required="" v-model="forgotEmail">
                      </div>
                  </div>
                  <div class="modal-footer">
                    <button type="button" class="btn btn-default" data-dismiss="modal">Mégsem</button>
                    <button type="button" class="btn btn-success" data-dismiss="modal" @click="forgottenPass">Küld</button>
                  </div>
                </div>
              </div>
            </div>
    </section>
</template>

<script>
import Endpoints from '@commons/communication/endpoints.js'
import AsyncLoader from '@commons/util/AsyncLoader.js'

export default{
    mixins:[Endpoints,AsyncLoader],
    computed:{
        isOrder:function () {
            return this.$route.query.order == 'true'?true:false;
        },
        isLoggedIn:function () {
            return this.$store.getters.isLoggedIn;
        }
    },
    data:function () {
        return {
            email: '',
            password: '',
            name: '',
            token:null,
            tempUserId:null,
            fbState:null,
            forgotEmail:'',
            newsletter:true,
        };
    },
    created:function () {
        var self = this;
        window.fbAsyncInit = function() {
            FB.init({
              appId      : '807885376051359',
              cookie     : true,
              xfbml      : true,
              version    : 'v2.11'
            });

            FB.getLoginStatus(function(response) {
                self.fbState = response;
            });
          };
          this.asyncLoad('https://connect.facebook.net/en_US/sdk.js','fbsdk',function (first) {
              console.log('fb loaded... '+first);
          });
    },
    methods:{
        login:function () {
            var self = this;

            this.connLogin(this.createHeader(),function success(r) {
                self.handleLogin(r)
            },function error(r) {
                toastr.error('Hibás felhasználónév vagy jelszó')
            })

        },
        handleLogin:function (r) {
            var self = this;

            toastr.success('Sikeres bejelentkezés!','Üdvözlünk '+r.data.user.name)
            this.$store.commit('setCurrentUser',r.data.user.name);
            self.saveToken(r.data.token);

            if (self.isOrder){
                self.connBasketGet(function (b) {
                    if (b.data.basketElements.length >0){
                        $("#dialog").modal();
                        self.token = r.data.token
                    }else{
                        self.reInitStore();
                        self.$router.push('/checkout/data');
                    }
                });
            }else{
                self.reInitStore();
                self.$router.push('/');
            }
        },
        register:function () {
            var self = this;

            if (this.password.length <6 ){
                toastr.warning('A jelszónak legalább 6 karakter hosszúnak kell lennie')
                return
            }else if(this.name.length <3){
                toastr.error('A név túl rövid')
                return
            }

            this.connRegister(this.createHeader(),{'name':this.name},function success(r) {
                if (self.newsletter){
                    self.subsribe();
                }
                self.login();
            },function error(r) {
                if (r.data.errorCode == 1001){
                    toastr.warning('Az email cím már foglalt, kérlek válassz másikat')
                }else{
                    toastr.error('Az adatok hibásan lettek kitöltve, kérlek ellenőrizd őket')
                }
            })
        },
        subsribe:function () {
            this.connSubscribeToNewsletter(this.email,this.name,function (r) {
            })
        },
        createHeader:function () {
            var o = {
                'Authorization':btoa(this.email+':'+this.password)
            }
            return o;
        },
        saveToken:function (token) {
            this.tempUserId = this.$store.getters.getCurrentToken;

            this.$store.commit('setLoggedIn',true)
            this.$store.commit('setCurrentToken',token)
        },
        reInitStore:function (onlyWatched = false) {
            var self = this;
            this.connMergeUsers(this.tempUserId, onlyWatched,function () {
                self.connBasketGet(function (r) {
                    self.$store.commit('setBasket',r.data);
                });
                self.connWatchedGet(function (r) {
                    self.$store.commit('setWatched',r.data);
                })
            })
        },
        dialogClicked:function (merge) {
            if (!merge){
                this.$store.commit('setOrderBasketToken',this.tempUserId);
            }
            this.reInitStore(!merge);

            if (merge){
                this.$router.push('/checkout/basket');
            }else{
                this.$router.push('/checkout/data');
            }
        },
        facebookLogin:function () {
            this.fbLoginStatus(this.fbState);
        },
        fbLoginStatus:function (state) {
            if (state.status == 'connected'){
                var token = state.authResponse.accessToken
                var self =this;
                this.connLoginFacebook(token,function (r) {
                    self.handleLogin(r);
                })
            }else{
                this.openFbLoginDialog();
            }
        },
        openFbLoginDialog:function () {
            var self = this;
            FB.login(function(response) {
                self.fbLoginStatus(response);
            }, {scope: 'public_profile,email'});
        },
        forgottenPass:function () {
            this.connForgotPass(this.forgotEmail,function (r) {
                toastr.success('Az emailt elküldtük a megadott email címre.');
            },function () {
                toastr.error('Ezzel az email címmel nem található felhasználó.');
            })
        }
    }
}
</script>

<style>
@media only screen
and (max-width : 576px) {
    .reg-box-custom{
        padding: 10px 10px !important;
    }
    .no-margin{
        margin:0px !important;
    }
}

</style>
<style scoped>
input{
    color:black;
}
.registration_box_area .form-group input{
    padding: 0px 10px;
}
</style>



// WEBPACK FOOTER //
// LoginForm.vue?1b8dbe68